export default {
    callable: (element: HTMLElement) => {
        const removeElements = element.querySelectorAll('img[data-image-remove]');
        [].forEach.call(removeElements, (ele: HTMLImageElement) => {
            const t = setTimeout(() => {
                if (ele.parentNode) {
                    ele.parentNode.removeChild(ele);
                }
            }, 2000);
            ele.addEventListener('load', () => {
                clearTimeout(t);
                if (ele.parentNode) {
                    ele.parentNode.removeChild(ele);
                }
            });
        });
    },
};
